import { decodeURISearchPart } from 'httongue';
import { rmatchDirSep } from '../matchers/rmatch-dir-sep.js';
import { rmatchName } from '../matchers/rmatch-name.js';
import { simpleRouteMatcher } from './simple-route-pattern.impl.js';
/**
 * Parses simple route pattern.
 *
 * Simple pattern can only match against whole entries. It does not support name prefixes or suffixes.
 *
 * Pattern format:
 *
 * - Empty string corresponds to empty pattern.
 *
 * - `/` matches directory separator.
 *   Corresponds to {@link rmatchDirSep}.
 *
 * - `/*` matches any route entry.
 *   Corresponds to {@link rmatchEntry}.
 *
 * - `/{capture}` captures any route entry as `capture`.
 *   Corresponds to {@link rcaptureEntry}.
 *
 * - `/**` matches any number of directories.
 *   Corresponds to {@link rmatchDirs}
 *
 * - `/{capture:**}` captures any number of directories as `capture`.
 *   Corresponds to {@link rcaptureDirs}.
 *
 * - Everything else matches verbatim and corresponds to {@link rmatchName}.
 *
 * The pattern parts are URL-decoded after parsing. So the pattern string may contain URL-encoded reserved and special
 * characters.
 *
 * @param pattern - Pattern string.
 * @returns Simple route pattern.
 */
export function simpleRoutePattern(pattern) {
    if (!pattern) {
        return [];
    }
    const result = [];
    const parts = pattern.split('/');
    for (const part of parts) {
        if (result.length) {
            result.push(rmatchDirSep);
        }
        if (!part) {
            continue;
        }
        const partMatcher = simpleRouteMatcher(part);
        if (partMatcher) {
            result.push(partMatcher);
        }
        else {
            result.push(rmatchName(decodeURISearchPart(part)));
        }
    }
    return result;
}
//# sourceMappingURL=simple-route-pattern.js.map